import { render, staticRenderFns } from "./cancelVIPConfirm.vue?vue&type=template&id=2932036b&"
import script from "./cancelVIPConfirm.vue?vue&type=script&lang=js&"
export * from "./cancelVIPConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2932036b')) {
      api.createRecord('2932036b', component.options)
    } else {
      api.reload('2932036b', component.options)
    }
    module.hot.accept("./cancelVIPConfirm.vue?vue&type=template&id=2932036b&", function () {
      api.rerender('2932036b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/vip/cancelVIPConfirm.vue"
export default component.exports